module.exports = __webpack_public_path__ + "img/Anisysop.2bc0504c.jpg";